import { Query } from '@tanstack/react-query';
import { ApiServicesContext } from 'context/ApiServicesContext';
import { useQueriesTyped } from 'hooks/useQueriesTyped';
import { useContext } from 'react';
import usePendingJobStore from 'stores/pendingJobsStore';
import { AsyncJob } from 'types/responses/AsyncJob';
import SnackbarUtils from 'utils/SnackbarUtils';

export default function useJobPoller() {
  const { jobService } = useContext(ApiServicesContext);
  const {
    jobs: pendingJobs,
    remove: removePendingJob,
    updateStatus: updatePendingJobStatus,
  } = usePendingJobStore();

  useQueriesTyped({
    queries: pendingJobs.map((pj) => {
      return {
        queryKey: ['FetchPendingJob', pj._id],
        queryFn: () => jobService.getJobById(pj._id),
        refetchInterval: (job: AsyncJob | undefined, query: Query) => {
          return job?.isCompleted || query.state.status === 'error' ? false : 5000;
        },
        refetchIntervalInBackground: true,
        onSuccess(job: AsyncJob) {
          if (job.isCompleted) {
            if (job.status === 'COMPLETED') {
              SnackbarUtils.success(job.getActionSuccessMessage(), { autoHideDuration: null });
            }
            if (job.status === 'ERROR') {
              SnackbarUtils.error(job.getActionErrorMessage(), { autoHideDuration: null });
            }
            removePendingJob(job._id);
          } else {
            updatePendingJobStatus(job._id, job.status);
          }
        },
      };
    }),
  });
}
